import * as React from 'react';
import {
  Button,
  Container,
  FileUpload,
  FormField,
  Header,
  SpaceBetween,
  Spinner,
  TextContent
} from '@cloudscape-design/components';
import { DocumentContext } from '../../context/documentContext';
import { createParagraphs } from '../../helpers/getFileData';
import { useContext, useEffect, useState } from 'react';
import { BaseRow, Importer, ImporterField } from 'react-csv-importer';
import { useNavigate } from 'react-router-dom';
import { createGunzip } from 'zlib';

export const FileSelector = () => {
  const [value, setValue] = useState<any[]>([]);
  const [docProcessing, setDocProcessing] = useState<boolean>(false);
  const {
    // filesToUpload,
    setFilesToUpload,
    setUploadProcessing,
    uploadFiles
  } = useContext(DocumentContext);
  const navigate = useNavigate();
  const [csvRowsArray, setCSVRowsArray] = useState<any[]>([]);
  const [showFileSelector, setShowFileSelector] = useState<boolean>(true);
  const [showCSVImporter, setShowCSVImporter] = useState<boolean>(true);
  // const [allowUpload, setAllowUpload] = useState<boolean>(false);
  const handleInputChange = async (files: File[]) => {
    console.log('e target files', files);
    if (files.length === 0) {
      setFilesToUpload([]);
    }
    setValue(files);
    setDocProcessing(true);
    const fileResults = await createParagraphs(files);
    if (fileResults !== null) {
      console.log('setting uploads', fileResults);
      setFilesToUpload(fileResults);
    }
    setDocProcessing(false);
  };

  const handleCSVImport = (fileName: string) => {
    console.log('running handleCSVImport');
    let sentences = csvRowsArray.map((ele) => {
      return `${ele.sentence1 ?? ''} ${ele.sentence2 ?? ''}`;
    });
    let tempObj = {
      sentences: sentences,
      name: fileName,
      uploaded: 'not started'
    };
    setFilesToUpload([tempObj]);
  };

  useEffect(() => {
    setUploadProcessing(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCSVRow = async (row: BaseRow) => {
    console.log('rowrow', row);
    const tempArray = csvRowsArray;
    tempArray.push(row);
    setCSVRowsArray([...tempArray]);
    console.log('new temp', tempArray);
  };

  const handleCancel = () => {
    navigate('/app/landing');
  };

  // useEffect(() => {

  //   if(filesToUpload.length === 1) {
  //     setAllowUpload(true);
  //   }
  // }, [filesToUpload])

  return (
    <Container
      header={
        <Header
          actions={
            <SpaceBetween direction="horizontal" size={'s'}>
              <Button
                onClick={() => uploadFiles()}
                // disabled={!(filesToUpload.length === 1)}
                // disabled={!allowUpload}
              >
                Upload
              </Button>
              <Button
                onClick={() => handleCancel()}
                // disabled={!(filesToUpload.length === 1)}
              >
                Cancel
              </Button>
            </SpaceBetween>
          }
        ></Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* <FormField label="Folder Name" >
          <Input value={currentFolder} type='text' onChange={({detail}) => setCurrentFolder(detail.value)} />
        </FormField> */}
        {showFileSelector ? (
          <FormField>
            {!docProcessing ? (
              <FileUpload
                onChange={({ detail }) => {
                  setShowCSVImporter(!showCSVImporter);
                  handleInputChange(detail.value);
                }}
                value={value}
                i18nStrings={{
                  uploadButtonText: (e) => (e ? 'Choose files' : 'Choose file'),
                  dropzoneText: (e) =>
                    e ? 'Drop files to upload' : 'Drop file to upload',
                  removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                  limitShowFewer: 'Show fewer files',
                  limitShowMore: 'Show more files',
                  errorIconAriaLabel: 'Error'
                }}
                showFileLastModified
                showFileSize
                showFileThumbnail
                tokenLimit={3}
                constraintText=".docx accepted"
                multiple={false}
                accept=".docx"
              />
            ) : (
              <SpaceBetween direction="vertical" size="s">
                <TextContent>
                  <p>Processing Document for upload</p>
                </TextContent>
                <Spinner size="large" />
              </SpaceBetween>
            )}
          </FormField>
        ) : null}

        {showCSVImporter ? (
          <div onClick={() => setShowFileSelector(false)}>
            <Importer
              dataHandler={async (rows, { startIndex }) => {
                // required, may be called several times
                // receives a list of parsed objects based on defined fields and user column mapping;
                // (if this callback returns a promise, the widget will wait for it before parsing more data)

                for (const row of rows) {
                  // console.log('row', row);
                  await handleCSVRow(row);
                }
              }}
              // onStart={() => setShowFileSelector(false)}
              defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
              // restartable={true} // optional, lets user choose to upload another file when import is complete
              onClose={({ file, preview, fields, columnFields }) => {
                handleCSVImport(file.name);
              }}
            >
              <ImporterField name="sentence1" label="Column to Analyse 1" />
              <ImporterField name="sentence2" label="Column to Analyse 2" />
            </Importer>
          </div>
        ) : null}
      </SpaceBetween>
    </Container>
  );
};
